module.exports = __webpack_public_path__ + "static/cross-border-47a0814dff20139dacbf140f9a6f04d4.svg";